const visualCategoryLinksConfig = {
  7616: [
    {
      friendlyName: "New in",
      linkUrl: "men/t-shirts-vests/new-in/cat/?cid=207782#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-relaxed-fit-t-shirt-in-dark-red/204188700-1-oxbloodred"
    },
    {
      friendlyName: "Crew Neck T-Shirts",
      linkUrl:
        "men/t-shirts-vests/crew-neck-t-shirts/cat/?cid=16851#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-muscle-t-shirt-with-crew-neck-in-brown/204186411-1-rockyroad"
    },
    {
      friendlyName: "Scoop neck T-Shirts",
      linkUrl:
        "men/t-shirts-vests/scoop-neck-t-shirts/cat/?cid=16852#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-t-shirt-with-scoop-neck-in-black/203441291-1-black"
    },
    {
      friendlyName: "Vests",
      linkUrl: "men/t-shirts-vests/vests/cat/?cid=9178#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-muscle-fit-vest-in-white/203371769-1-white"
    },
    {
      friendlyName: "Plain T-shirts",
      linkUrl:
        "men/t-shirts-vests/plain-t-shirts/cat/?cid=9171#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-muscle-t-shirt-with-crew-neck-in-cream/204186342-1-coconutmilk"
    },
    {
      friendlyName: "Printed T-Shirts",
      linkUrl:
        "men/t-shirts-vests/printed-t-shirts/cat/?cid=9172#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-oversized-t-shirt-in-dark-green-with-nashville-city-print/204396091-1-scarab"
    },
    {
      friendlyName: "Long Sleeve T-Shirts",
      linkUrl:
        "men/t-shirts-vests/long-sleeve-t-shirts/cat/?cid=13084#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-long-sleeve-muscle-t-shirt-in-light-brown/203616153-1-deeptaupe"
    },
    {
      friendlyName: "Striped T-Shirts",
      linkUrl:
        "men/t-shirts-vests/striped-t-shirts/cat/?cid=9887#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-stripe-t-shirt-in-black-and-ecru/200271405-1-black"
    },
    {
      friendlyName: "V Neck T-Shirts",
      linkUrl:
        "men/t-shirts-vests/v-neck-t-shirts/cat/?cid=16853#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-cotton-blend-t-shirt-with-v-neck-in-black/204187373-1-black"
    },
    {
      friendlyName: "Logo T-Shirts",
      linkUrl:
        "men/t-shirts-vests/logo-t-shirts/cat/?cid=16056#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/carhartt-wip-scrawl-t-shirt-in-yellow/203399058-1-yellow?"
    }
  ],
  26090: [
    {
      friendlyName: "Tops",
      linkUrl: "men/sportswear/tops/cat/?cid=27181#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/nike-training-dri-fit-t-shirt-in-grey/203655047-1-grey"
    },
    {
      friendlyName: "Shorts",
      linkUrl: "men/sportswear/shorts/cat/?cid=27178#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/hiit-essential-2-in-1-mesh-overlay-shorts/203792471-1-black"
    },
    {
      friendlyName: "Shoes",
      linkUrl: "men/sportswear/shoes/cat/?cid=27179#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/new-balance-running-fresh-foam-more-trainers-in-white-and-citrus-green/202420398-1-white"
    },
    {
      friendlyName: "Gym & Training",
      linkUrl: "men/sportswear/gym-training/cat/?cid=27183#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-training-baselayer-long-sleeve-t-shirt-with-mesh-panels/203773507-4"
    },
    {
      friendlyName: "Football",
      linkUrl: "men/sportswear/football/cat/?cid=27182#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/adidas-football-arsenal-fc-training-jersey-in-off-white/204213362-1-offwhitecollegiate"
    },
    {
      friendlyName: "Running",
      linkUrl: "men/sportswear/running/cat/?cid=27191#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/adidas-football-tiro-23-joggers-black-and-blue/203467547-1-black"
    },
    {
      friendlyName: "Trousers & Tights",
      linkUrl:
        "men/sportswear/trousers-tights/cat/?cid=27177#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-icon-super-skinny-training-jogger-with-quick-dry/200360242-1-khaki"
    },
    {
      friendlyName: "Outdoors",
      linkUrl: "men/sportswear/outdoors/cat/?cid=27184#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/berghaus-deluge-pro-20-insulated-jacket-in-black/24116405-1-jetblack"
    },
    {
      friendlyName: "Accessories",
      linkUrl: "men/sportswear/accessories/cat/?cid=27176#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/nike-hyperfuel-18oz-water-bottle-in-orange/202578954-1-orange"
    },
    {
      friendlyName: "Ski & Snowboard",
      linkUrl: "men/sportswear/ski-snowboard/cat/?cid=27520#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/planks-high-rider-bib-in-black/202699727-1-black"
    }
  ],
  4208: [
    {
      friendlyName: "Slim jeans",
      linkUrl: "men/jeans/slim-jeans/cat/?cid=5054#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-stretch-slim-jeans-in-light-wash-blue/203005827-1-blue"
    },

    {
      friendlyName: "Skinny jeans",
      linkUrl: "men/jeans/skinny-jeans/cat/?cid=5403#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-skinny-jeans-in-dark-wash-blue/203136605-1-blue"
    },

    {
      friendlyName: "Straight jeans",
      linkUrl: "men/jeans/straight-jeans/cat/?cid=5052#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-wide-straight-leg-jeans-in-grey-with-destroyed-hem/200213996-1-grey"
    },

    {
      friendlyName: "Tapered jeans",
      linkUrl: "men/jeans/tapered-jeans/cat/?cid=16982#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-relaxed-tapered-jeans-in-vintage-mid-wash/200213977-1-midwashblue"
    },

    {
      friendlyName: "Riped jeans",
      linkUrl: "men/jeans/ripped-jeans/cat/?cid=19790#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-baggy-jeans-in-light-wash-blue-with-rips/200752637-1-lightwashblue"
    },

    {
      friendlyName: "Wide jeans",
      linkUrl: "men/jeans/wide-jeans/cat/?cid=50030#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-extreme-wide-leg-jeans-with-heavy-tint-in-blue-wash/203141331-1-blue"
    },

    {
      friendlyName: "Loose jeans",
      linkUrl: "men/jeans/loose-jeans/cat/?cid=5055#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-wide-straight-leg-jeans-in-tinted-mid-wash/200826668-1-midwashblue"
    },

    {
      friendlyName: "Super skinny jeans",
      linkUrl: "men/jeans/super-skinny-jeans/cat/?cid=16463#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-spray-on-jeans-with-power-stretch-in-washed-black/200827258-1-washedblack"
    },

    {
      friendlyName: "Light wash jeans",
      linkUrl: "men/jeans/light-wash-jeans/cat/?cid=50032#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-balloon-jeans-in-midwash-blue/204549943-1-blue"
    },

    {
      friendlyName: "Dark wash jeans",
      linkUrl: "men/jeans/dark-wash-jeans/cat/?cid=11059#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-co-ord-baggy-denim-jeans-in-blue-rinse-wash/203112930-1-blue"
    }
  ],
  4910: [
    {
      friendlyName: "Cargo trousers",
      linkUrl:
        "men/trousers-chinos/cargo-trousers/cat/?cid=14273#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-relaxed-fit-cargo-trousers-in-black-tie-dye/203535244-4"
    },

    {
      friendlyName: "Chinos",
      linkUrl: "men/trousers-chinos/chinos/cat/?cid=14051#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-relaxed-chinos-in-beige/203104197-1-brindle"
    },

    {
      friendlyName: "Smart trousers",
      linkUrl:
        "men/trousers-chinos/smart-trousers/cat/?cid=14052#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-smart-wide-leg-wool-mix-trousers-in-charcoal-wide-herringbone/201578413-1-charcoal"
    },

    {
      friendlyName: "Skinny trousers",
      linkUrl:
        "men/trousers-chinos/skinny-trousers/cat/?cid=20999#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/groups/asos-design-smart-co-ord-skinny-in-black-corduroy/139539-group-1"
    },

    {
      friendlyName: "Cropped trousers",
      linkUrl:
        "men/trousers-chinos/cropped-trousers/cat/?cid=21856#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-smart-tapered-pinstripe-trousers-in-navy/13724953-1-navy"
    },

    {
      friendlyName: "Linen trousers",
      linkUrl:
        "men/trousers-chinos/linen-trousers/cat/?cid=50538#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-linen-mix-wide-leg-smart-trousers-in-brown-crinkle/204185629-1-brown"
    },

    {
      friendlyName: "Cords",
      linkUrl: "men/trousers-chinos/cords/cat/?cid=14272#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-skinny-stretch-cord-trousers-in-khaki/202776326-1-fourleafclover"
    }
  ],
  4209: [
    {
      friendlyName: "Trainers",
      linkUrl:
        "men/shoes-boots-trainers/trainers/cat/?cid=5775#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/adidas-originals-gum-sole-handball-spezial-trainers-in-core-black-grey/203415179-1-black"
    },

    {
      friendlyName: "Shoes",
      linkUrl:
        "men/shoes-boots-trainers/shoes/cat/?cid=27116#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-chunky-sole-derby-shoes-in-black-faux-leather/203624622-1-black"
    },

    {
      friendlyName: "Smart shoes",
      linkUrl:
        "men/shoes-boots-trainers/smart-shoes/cat/?cid=5773#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-western-chain-detail-lace-up-shoes-in-black-polished-faux-leather/204057472-1-black"
    },

    {
      friendlyName: "Boots",
      linkUrl: "men/shoes-boots-trainers/boots/cat/?cid=5774#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-cuban-heeled-chelsea-boots-in-denim-with-square-toe/203807216-1-denim"
    },

    {
      friendlyName: "Sliders & flipflops",
      linkUrl:
        "men/shoes-boots-trainers/sliders-flip-flops/cat/?cid=17514#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-chunky-sliders-in-orange/203986162-1-orange"
    },

    {
      friendlyName: "Loafers",
      linkUrl:
        "men/shoes-boots-trainers/loafers/cat/?cid=11247#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-chunky-loafers-in-white-leather-with-silver-hardware/203695696-1-white"
    },

    {
      friendlyName: "Sandals",
      linkUrl:
        "men/shoes-boots-trainers/sandals/cat/?cid=6593#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-two-strap-sandals-in-stone-faux-suede/204127400-1-stone"
    },

    {
      friendlyName: "Slippers",
      linkUrl:
        "men/shoes-boots-trainers/slippers/cat/?cid=14328#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-slip-on-slippers-in-khaki-with-beige-faux-fur-lining/200355818-1-khaki"
    },

    {
      friendlyName: "Brogues & Derby Shoes",
      linkUrl:
        "men/shoes-boots-trainers/brogues-derby-shoes/cat/?cid=11941#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-brogue-shoes-with-chunky-sole-in-brown-leather/200841453-2"
    },

    {
      friendlyName: "Chelsea Boots",
      linkUrl:
        "men/shoes-boots-trainers/chelsea-boots/cat/?cid=18695#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-chelsea-calf-boots-with-chunky-sole-in-black-faux-leather/202479712-1-black"
    }
  ],
  4210: [
    {
      friendlyName: "Caps & hats",
      linkUrl: "men/accessories/caps-hats/cat/?cid=6517#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-trucker-cap-with-embroidery-in-washed-green/203898983-1-lightgreen"
    },

    {
      friendlyName: "Belts",
      linkUrl: "men/accessories/belts/cat/?cid=6474#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-smart-leather-belt-with-burnished-silver-buckle-in-black/203859525-1-black"
    },

    {
      friendlyName: "Wallets",
      linkUrl: "men/accessories/wallets/cat/?cid=6516#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-textured-real-leather-wallet-with-contrast-in-black-and-green/203939695-1-black"
    },

    {
      friendlyName: "Ties",
      linkUrl: "men/accessories/ties/cat/?cid=6520#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-slim-tie-in-purple-floral/202084917-1-purple"
    },

    {
      friendlyName: "Gloves",
      linkUrl: "men/accessories/gloves/cat/?cid=11854#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-faux-leather-gloves-in-chocolate-brown/202783139-1-brown"
    },

    {
      friendlyName: "Scarves",
      linkUrl: "men/accessories/scarves/cat/?cid=6518#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-standard-scarf-in-mustard/202738056-1-mustard"
    },

    {
      friendlyName: "Sunglasses",
      linkUrl: "men/accessories/sunglasses/cat/?cid=6519#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-retro-aviator-sunglasses-in-black-with-edge-detail-and-blue-lens/201901541-1-black"
    },

    {
      friendlyName: "Shirt accessories",
      linkUrl:
        "men/accessories/shirt-accessories/cat/?cid=17545#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-3-pack-collar-tips-cufflinks-and-tie-bar-set-in-silver-tone/204529531-1-silver"
    },

    {
      friendlyName: "Face coverings",
      linkUrl:
        "men/accessories/face-coverings/cat/?cid=50036#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-3-pack-face-covering-with-adjustable-straps-nose-clip-and-bag-in-black/21825339-2"
    },

    {
      friendlyName: "Glasses",
      linkUrl: "men/accessories/glasses/cat/?cid=19526#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/akjaerbede-bate-blue-light-glasses-in-grey-transparent/201748623-1-grey"
    }
  ],
  5678: [
    {
      friendlyName: "Skinny fit suits",
      linkUrl: "men/suits/skinny-fit-suits/cat/?cid=13533#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/groups/asos-design-skinny-tuxedo-in-black/140947-group-1"
    },

    {
      friendlyName: "Slim fit suits",
      linkUrl: "men/suits/slim-fit-suits/cat/?cid=13532#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/groups/asos-design-slim-suit-trouser-in-forest-green/144295-group-1"
    },

    {
      friendlyName: "Suit trousers",
      linkUrl: "men/suits/suit-trousers/cat/?cid=14999#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-wide-leg-suit-trousers-in-navy-plisse/203478946-1-navy"
    },

    {
      friendlyName: "Suits for weddings",
      linkUrl: "men/suits/suits-for-weddings/cat/?cid=14673#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-wedding-slim-suit-jacket-in-brown-texture/202270011-1-brown"
    },

    {
      friendlyName: "Blazers",
      linkUrl: "men/suits/blazers/cat/?cid=11903#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-wedding-skinny-blazer-with-gold-buttons-in-sage-green/202935519-1-sagegreen"
    },

    {
      friendlyName: "Super Skinny Fit Suits",
      linkUrl:
        "men/suits/super-skinny-fit-suits/cat/?cid=20996#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/groups/asos-design-super-skinny-wedding-suit-in-brown-micro-check/125706-group-1"
    },

    {
      friendlyName: "Waistcoats",
      linkUrl: "men/suits/waistcoats/cat/?cid=12287#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-slim-suit-waistcoat-in-charcoal/203458590-1-charcoal"
    },

    {
      friendlyName: "Tuxedos",
      linkUrl: "men/suits/tuxedos/cat/?cid=15597#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-super-skinny-velvet-tuxedo-blazer-in-white/202919258-1-white"
    },

    {
      friendlyName: "Three Piece Suits",
      linkUrl: "men/suits/three-piece-suits/cat/?cid=21857#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/groups/asos-design-slim-linen-mix-suit-in-navy/144296-group-1"
    },

    {
      friendlyName: "Linen suits",
      linkUrl: "men/suits/linen-suits/cat/?cid=19430#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-wedding-super-skinny-suit-jacket-in-stretch-cotton-linen-in-stone-check/13884493-4"
    }
  ],
  3606: [
    {
      friendlyName: "Gilets",
      linkUrl: "men/jackets-coats/gilets/cat/?cid=14886#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-utility-gilet-with-pockets-in-light-blue/203644793-4"
    },

    {
      friendlyName: "Bomber jackets",
      linkUrl:
        "men/jackets-coats/bomber-jackets/cat/?cid=16245#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-oversized-bomber-jacket-in-sage-green/203645009-1-lightgreen"
    },

    {
      friendlyName: "Puffer jackets",
      linkUrl:
        "men/jackets-coats/puffer-jackets/cat/?cid=28642#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-puffer-jacket-with-detachable-hood-in-orange/200622411-1-orange"
    },

    {
      friendlyName: "Denim jackets",
      linkUrl:
        "men/jackets-coats/denim-jackets/cat/?cid=11908#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-classic-denim-jacket-in-indigo/200900513-1-indigo"
    },

    {
      friendlyName: "Trench coats",
      linkUrl:
        "men/jackets-coats/trench-coats/cat/?cid=11902#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-oversized-trench-coat-in-brown/203345544-1-tan"
    },

    {
      friendlyName: "Overcoats",
      linkUrl: "men/jackets-coats/overcoats/cat/?cid=20990#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-oversized-brown-check-overcoat-with-wool/203194412-1-brown"
    },

    {
      friendlyName: "Leather jackets",
      linkUrl:
        "men/jackets-coats/leather-jackets/cat/?cid=11760#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-real-leather-harrington-jacket-in-black/203183609-1-black"
    },

    {
      friendlyName: "Shackets",
      linkUrl: "men/jackets-coats/shackets/cat/?cid=50080#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-regular-fit-faux-leather-shacket-in-croc-blue/203644812-1-lightblue"
    },

    {
      friendlyName: "Windbreakers",
      linkUrl:
        "men/jackets-coats/windbreakers/cat/?cid=21859#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-wind-breaker-in-beige/204422881-1-beige"
    },

    {
      friendlyName: "Parkas",
      linkUrl: "men/jackets-coats/parkas/cat/?cid=12931#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-shower-resistant-parka-coat-with-borg-lining-in-khaki/200401759-1-green"
    }
  ],
  3602: [
    {
      friendlyName: "Casual shirts",
      linkUrl: "men/shirts/casual-shirts/cat/?cid=17410#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-oversized-boxy-fit-ribbed-jacket-in-brown/204277715-1-sealbrown"
    },

    {
      friendlyName: "Check shirts",
      linkUrl: "men/shirts/check-shirts/cat/?cid=12299#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-overshirt-in-navy-wool-mix-check-with-borg-collar/202667890-1-navy"
    },

    {
      friendlyName: "Plain shirts",
      linkUrl: "men/shirts/plain-shirts/cat/?cid=20295#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-relaxed-viscose-shirt-in-vintage-blue/203789247-1-vintageblue"
    },

    {
      friendlyName: "Smart shirts",
      linkUrl: "men/shirts/smart-shirts/cat/?cid=14480#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-premium-easy-iron-slim-fit-twill-shirt-with-cutaway-collar-in-white/203469655-1-white"
    },

    {
      friendlyName: "Short sleeve shirts",
      linkUrl:
        "men/shirts/short-sleeve-shirts/cat/?cid=13802#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-button-through-jersey-shirt-in-burgundy/203133847-1-portroyale"
    },

    {
      friendlyName: "Printed shirts",
      linkUrl: "men/shirts/printed-shirts/cat/?cid=13803#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-regular-sheer-shirt-with-ruffle-front-and-heart-devore-in-black/203522615-1-black"
    },

    {
      friendlyName: "Oxford shirts",
      linkUrl: "men/shirts/oxford-shirts/cat/?cid=14478#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-slim-oxford-shirt-in-burgundy-yarn-dye/202737302-1-burgundy"
    },

    {
      friendlyName: "Denim shirts",
      linkUrl: "men/shirts/denim-shirts/cat/?cid=13024#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-oversized-denim-shirt-in-vintage-mid-wash-blue/23778687-1-midwash"
    },

    {
      friendlyName: "Stripe shirts",
      linkUrl: "men/shirts/stripe-shirts/cat/?cid=13804#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-satin-shirt-in-brown-stripe-with-70s-collar/202918622-1-purple"
    },

    {
      friendlyName: "Grandad collar shirts",
      linkUrl:
        "men/shirts/grandad-collar-shirts/cat/?cid=26230#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-90s-oversized-linen-shirt-with-grandad-neck-in-blue/203680346-1-blue"
    }
  ],
  8799: [
    {
      friendlyName: "Day Dresses",
      linkUrl: "women/dresses/day-dresses/cat/?cid=19680#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-textured-midi-tea-dress-in-yellow-check/204366849-1-yellowcheck"
    },
    {
      friendlyName: "Dresses for Weddings",
      linkUrl:
        "women/dresses/dresses-for-weddings/cat/?cid=13934#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-flutter-sleeve-cowl-neck-maxi-dress-in-vintage-floral-print/204005239-1-vintagefloral"
    },
    {
      friendlyName: "Evening Dresses",
      linkUrl: "women/dresses/evening-dresses/cat/?cid=8857#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-scoop-back-chiffon-ruffle-hem-mini-dress-in-blue/204300777-1-blue"
    },
    {
      friendlyName: "Mini Dresses",
      linkUrl: "women/dresses/mini-dresses/cat/?cid=13597#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-flutter-sleeve-cowl-neck-mini-dress-in-bright-red/204005107-3"
    },
    {
      friendlyName: "Midi Dresses",
      linkUrl: "women/dresses/midi-dresses/cat/?cid=12899#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-halter-shoulder-midi-dress-in-black/204482961-1-black"
    },
    {
      friendlyName: "Maxi Dresses",
      linkUrl: "women/dresses/maxi-dresses/cat/?cid=9979#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-curve-waisted-maxi-dress-in-blue-floral-print/204247543-1-bluefloralprint"
    },
    {
      friendlyName: "Party Dresses",
      linkUrl: "women/dresses/party-dresses/cat/?cid=11057#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-embellished-wrap-mini-dress-with-fringe-beaded-hem-in-blush/202661471-1-blush"
    },
    {
      friendlyName: "Bridesmaid Dresses",
      linkUrl:
        "women/dresses/bridesmaid-dresses/cat/?cid=15156#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-bridesmaids-batwing-bias-cut-maxi-dress-in-sage/204267616-1-sage"
    },
    {
      friendlyName: "Summer Dresses",
      linkUrl: "women/dresses/summer-dresses/cat/?cid=10860#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-knitted-racer-mini-dress-in-white/204185130-1-white"
    },
    {
      friendlyName: "Wedding Dresses",
      linkUrl: "women/dresses/wedding-dresses/cat/?cid=25408#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-edition-elodie-long-sleeve-satin-drape-bardot-wedding-dress-in-ivory/203922527-1-ivory"
    }
  ],
  26091: [
    {
      friendlyName: "Leggings",
      linkUrl: "women/sportswear/leggings/cat/?cid=27163#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-icon-legging-with-bum-sculpt-seam-detail-and-pocket/203038240-1-darkpurple"
    },
    {
      friendlyName: "Tops",
      linkUrl: "women/sportswear/tops/cat/?cid=27167#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-seamless-vest-in-marl/202930175-1-green"
    },
    {
      friendlyName: "Shoes",
      linkUrl: "women/sportswear/shoes/cat/?cid=27165#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/new-balance-running-fresh-foam-more-trainers-in-white-and-green/202424042-1-white"
    },
    {
      friendlyName: "Sports bras",
      linkUrl: "women/sportswear/sports-bras/cat/?cid=27168#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/nike-training-grx-indy-light-support-sports-bra-in-black/202339123-1-black"
    },
    {
      friendlyName: "Shorts",
      linkUrl: "women/sportswear/shorts/cat/?cid=27164#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/new-balance-running-relentless-legging-shorts-in-dusky-pink/202424227-1-lightpink"
    },
    {
      friendlyName: "Gym & training",
      linkUrl: "women/sportswear/gym-training/cat/?cid=27171#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/the-north-face-training-flex-high-rise-7-8-leggings-in-navy/203304014-1-navy"
    },
    {
      friendlyName: "Running",
      linkUrl: "women/sportswear/running/cat/?cid=27172#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/nike-running-air-dri-fit-long-sleeve-crew-neck-top-in-khaki/202920521-1-green"
    },
    {
      friendlyName: "Ski & Snowboard",
      linkUrl:
        "women/sportswear/ski-snowboard/cat/?cid=27519#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/topshop-sno-high-waisted-ski-salopettes-in-monochrome/202252798-1-mono"
    },
    {
      friendlyName: "Outdoors",
      linkUrl: "women/sportswear/outdoors/cat/?cid=27173#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/napapijri-a-box-puffer-jacket-in-brown/203125271-1-brown"
    },
    {
      friendlyName: "Accessories",
      linkUrl: "women/sportswear/accessories/cat/?cid=27162#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/nike-training-big-mouth-20-625ml-water-bottle-in-blue/202579079-1-midblue"
    }
  ],
  4169: [
    {
      friendlyName: "Shirts & Blouses",
      linkUrl: "women/tops/shirts-blouses/cat/?cid=11318#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-curve-relaxed-polo-shirt-with-deep-v-in-sand/203962735-1-sand"
    },
    {
      friendlyName: "T-Shirts & Vests",
      linkUrl: "women/tops/t-shirts-vests/cat/?cid=4718#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-baby-tee-with-italia-graphic-in-blue/204422692-2"
    },
    {
      friendlyName: "Evening Tops",
      linkUrl: "women/tops/evening-tops/cat/?cid=11320#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-ruched-corset-with-curved-neckline-in-black/202871350-1-black"
    },
    {
      friendlyName: "Corset Tops",
      linkUrl: "women/tops/corset-tops/cat/?cid=50070#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-faux-leather-corset-in-snake-print-co-ord/202891977-1-snake"
    },
    {
      friendlyName: "Summer Tops",
      linkUrl: "women/tops/summer-tops/cat/?cid=28018#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-tie-front-frill-neck-sheer-blouse-in-print/202871121-3"
    },
    {
      friendlyName: "Crop Tops",
      linkUrl: "women/tops/crop-tops/cat/?cid=15196#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-edition-racer-front-cropped-knitted-top-in-camel/204171948-1-camel"
    },
    {
      friendlyName: "Bodysuits",
      linkUrl: "women/tops/bodysuits/cat/?cid=11323#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-cami-mesh-cupped-bodysuit-in-graphic-print/204356006-1-graphicprint"
    },
    {
      friendlyName: "Camis",
      linkUrl: "women/tops/camis/cat/?cid=15202#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-scoop-neck-cami-in-satin-in-black/204368778-1-black"
    },
    {
      friendlyName: "Printed Tops",
      linkUrl: "women/tops/printed-tops/cat/?cid=12800#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-longline-mesh-fairy-hem-corset-top-in-graphic-print/204333602-1-graphicprint"
    },
    {
      friendlyName: "Long sleeve tops",
      linkUrl: "women/tops/long-sleeve-tops/cat/?cid=17334#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-2-in-1-textured-second-skin-long-sleeve-top-in-blue/204520196-1-blue"
    }
  ],
  1314: [
    {
      friendlyName: "Makeup",
      linkUrl: "women/face-body/makeup/cat/?cid=5020#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/bobbi-brown-luxe-lipstick-pale-mauve/204206727-1-palemauve"
    },
    {
      friendlyName: "Skin Care",
      linkUrl: "women/face-body/skin-care/cat/?cid=4540#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/the-ordinary-balance-set-worth-2530/22184712-1-nocolour"
    },
    {
      friendlyName: "Hair Care",
      linkUrl: "women/face-body/hair-care/cat/?cid=5021#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/olaplex-no4-bond-maintenance-shampoo-85oz-250ml/20626276-1-no4"
    },
    {
      friendlyName: "Face & Body Gifts",
      linkUrl:
        "women/face-body/face-body-gifts/cat/?cid=14312#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/the-ritual-of-ayurveda-medium-gift-set/203845311-1-nocolour"
    },
    {
      friendlyName: "Tools & Accessories",
      linkUrl:
        "women/face-body/tools-accessories/cat/?cid=16793#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/ghd-duet-2-in-1-hot-air-styler-in-black/204604234-1-nocolour"
    },
    {
      friendlyName: "Tanning",
      linkUrl: "women/face-body/tanning/cat/?cid=5606#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/bondi-sands-self-tanning-foam-dark-200ml/21430975-1-nocolour"
    },
    {
      friendlyName: "Body care",
      linkUrl: "women/face-body/body-care/cat/?cid=4896#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/aveeno-daily-moisturising-creamy-oil-300ml/203863681-1-nocolour"
    },
    {
      friendlyName: "Fragrances",
      linkUrl: "women/face-body/fragrances/cat/?cid=28425#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/kayali-utopia-vanilla-coco-21-100ml/200894041-1-nocolour"
    },
    {
      friendlyName: "Wellness",
      linkUrl: "women/face-body/wellness/cat/?cid=50072#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/neom-perfect-nights-sleep-lavender-jasmine-basil-3-wick-scented-candle/20738450-1-nocolour"
    },
    {
      friendlyName: "Nails",
      linkUrl: "women/face-body/nails/cat/?cid=5607#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/essie-original-nail-polish-meet-me-at-sunset/9838200-2"
    }
  ],
  4172: [
    {
      friendlyName: "Trainers",
      linkUrl: "women/shoes/trainers/cat/?cid=6456#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/adidas-originals-gum-sole-hamburg-trainers-in-brown/204169643-2"
    },
    {
      friendlyName: "Heels",
      linkUrl: "women/shoes/heels/cat/?cid=6461#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-nydia-asymmetric-barely-there-heeled-sandals-in-black/203741723-2"
    },
    {
      friendlyName: "Sandals",
      linkUrl: "women/shoes/sandals/cat/?cid=6458#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-fantasy-studded-flat-sandal-in-taupe/203856455-2"
    },
    {
      friendlyName: "Boots",
      linkUrl: "women/shoes/boots/cat/?cid=6455#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-comet-fringe-western-knee-boot-in-beige/203670328-1-beige"
    },
    {
      friendlyName: "Flat shoes",
      linkUrl: "women/shoes/flat-shoes/cat/?cid=6459#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-magnus-chunky-loafers-in-black/202349701-4"
    },
    {
      friendlyName: "Wide fit shoes",
      linkUrl: "women/shoes/wide-fit-shoes/cat/?cid=19886#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-wide-fit-simmer-slingback-stiletto-mid-shoes-in-blue/203796659-4"
    },
    {
      friendlyName: "Platform shoes",
      linkUrl: "women/shoes/platform-shoes/cat/?cid=14208#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/dr-martens-vegan-sinclair-boots-in-black/22621976-4"
    },
    {
      friendlyName: "Flat Sandals",
      linkUrl: "women/shoes/flat-sandals/cat/?cid=17170#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-fortune-hardware-flat-sandal-in-gold/203804936-1-gold"
    },
    {
      friendlyName: "Heeled sandals",
      linkUrl: "women/shoes/heeled-sandals/cat/?cid=17169#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-nate-platform-heeled-sandals-in-silver/202259160-4"
    },
    {
      friendlyName: "Mules",
      linkUrl: "women/shoes/mules/cat/?cid=50073#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-marshall-chunky-chain-flat-mules-in-black-croc/202258601-4"
    }
  ],
  4174: [
    {
      friendlyName: "Hats",
      linkUrl: "women/accessories/hats/cat/?cid=6449#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-straw-open-weave-floppy-hats-in-two-tone-weave/204195410-4"
    },
    {
      friendlyName: "Hair accessories",
      linkUrl:
        "women/accessories/hair-accessories/cat/?cid=11412#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-hairband-with-bow-detail-in-black/204294091-4"
    },
    {
      friendlyName: "Belts",
      linkUrl: "women/accessories/belts/cat/?cid=6448#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-suede-eyelet-waist-and-hip-jeans-belt-in-tan/201449179-4"
    },
    {
      friendlyName: "Scarves",
      linkUrl: "women/accessories/scarves/cat/?cid=6452#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/reclaimed-vintage-crochet-skinny-scarf-in-multi/203778080-3"
    },
    {
      friendlyName: "Gloves",
      linkUrl: "women/accessories/gloves/cat/?cid=11990#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asyou-pu-gloves-with-pink-faux-fur-trim-in-black/203151027-4"
    },
    {
      friendlyName: "Hairbands",
      linkUrl: "women/accessories/hairbands/cat/?cid=19829#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-headband-with-braided-design-in-emerald-satin/202742177-1-emerald"
    },
    {
      friendlyName: "Headscarves",
      linkUrl: "women/accessories/headscarves/cat/?cid=20267#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-polysatin-medium-headscarf-in-pink/202321078-1-pink"
    },
    {
      friendlyName: "Sunglasses",
      linkUrl: "women/accessories/sunglasses/cat/?cid=4545#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-mid-square-sunglasses-with-temple-detail-in-white-acetate-transfer/204139477-4"
    },
    {
      friendlyName: "Glasses",
      linkUrl: "women/accessories/glasses/cat/?cid=19820#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/quay-high-key-mini-blue-light-aviator-glasses-in-gold/201795068-1-gold"
    },
    {
      friendlyName: "Wedding accessories",
      linkUrl:
        "women/accessories/wedding-accessories/cat/?cid=15120#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/easilocks-wedding-full-collection-bride/204343531-1-nocolour"
    }
  ],
  3630: [
    {
      friendlyName: "High Waisted Jeans",
      linkUrl:
        "women/jeans/high-waisted-jeans/cat/?cid=15159#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-slim-straight-jeans-in-mid-wash-blue/204015281-4"
    },
    {
      friendlyName: "Mom Jeans",
      linkUrl: "women/jeans/mom-jeans/cat/?cid=20310#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-slim-mom-jeans-in-light-blue/204334521-1-lightblue"
    },
    {
      friendlyName: "Wide Leg Jeans",
      linkUrl: "women/jeans/wide-leg-jeans/cat/?cid=28017#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/topshop-carpenter-jeans-in-authentic-light-blue/204207882-1-authenticblue"
    },
    {
      friendlyName: "Skinny Jeans",
      linkUrl: "women/jeans/skinny-jeans/cat/?cid=10769#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-sculpting-skinny-jean-in-mid-blue/203968421-1-midblue"
    },
    {
      friendlyName: "Flare Jeans",
      linkUrl: "women/jeans/flare-jeans/cat/?cid=11316#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-petite-flared-jeans-in-mid-blue/204265329-1-midblue"
    },
    {
      friendlyName: "Cargo Jeans",
      linkUrl: "women/jeans/50774/cat/?cid=50774#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-ultimate-cargo-jean-in-light-blue/204450127-1-lightblue"
    },
    {
      friendlyName: "Ripped jeans",
      linkUrl: "women/jeans/ripped-jeans/cat/?cid=19823#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-loose-straight-jeans-with-knee-rips-in-light-blue/204225413-3"
    },
    {
      friendlyName: "White jeans",
      linkUrl: "women/jeans/white-jeans/cat/?cid=28188#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-power-stretch-flare-jean-in-white/204079046-1-white"
    },
    {
      friendlyName: "Boyfriend jeans",
      linkUrl: "women/jeans/boyfriend-jeans/cat/?cid=11309#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-oversized-boyfriend-jean-in-washed-black-with-chunky-stitch/204189317-1-washedblack"
    },
    {
      friendlyName: "Black jeans",
      linkUrl: "women/jeans/black-jeans/cat/?cid=28189#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-dad-jean-in-washed-black/204162586-1-washedblack"
    }
  ],
  2640: [
    {
      friendlyName: "Wide Leg Trousers",
      linkUrl:
        "women/trousers-leggings/wide-leg-trousers/cat/?cid=17400#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/groups/asos-design-wide-leg-trouser-in-twill-co-ord/145172-group-1"
    },
    {
      friendlyName: "Flares",
      linkUrl:
        "women/trousers-leggings/flares/cat/?cid=12917#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/groups/asos-design-lace-up-corset-and-flare-in-stone-co-ord/98283-group-1"
    },
    {
      friendlyName: "Work trousers",
      linkUrl:
        "women/trousers-leggings/work-trousers/cat/?cid=15203#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-hourglass-slim-skim-cigarette-trouser-in-black/203463134-3"
    },
    {
      friendlyName: "Cargo trousers",
      linkUrl:
        "women/trousers-leggings/cargo-trousers/cat/?cid=50458#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-oversized-cargo-trouser-with-multi-pocket-in-khaki/203346614-1-khaki"
    },
    {
      friendlyName: "Straight Leg Trousers",
      linkUrl:
        "women/trousers-leggings/straight-leg-trousers/cat/?cid=17399#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-rib-dad-trouser-in-charcoal/203197023-1-charcoal"
    },
    {
      friendlyName: "Leather Leggings & Trousers",
      linkUrl:
        "women/trousers-leggings/leather-leggings-trousers/cat/?cid=17934#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-leather-look-ultimate-straight-leg-trouser-in-mink/200813896-1-brown"
    },
    {
      friendlyName: "Leggings",
      linkUrl:
        "women/trousers-leggings/leggings/cat/?cid=16037#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-leggings-in-black/203403630-1-black"
    },
    {
      friendlyName: "Skinny trousers",
      linkUrl:
        "women/trousers-leggings/skinny-trousers/cat/?cid=17398#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/groups/asos-design-skinny-cargo-in-khaki-co-ord/127357-group-1"
    },
    {
      friendlyName: "Cropped trousers",
      linkUrl:
        "women/trousers-leggings/cropped-trousers/cat/?cid=12911#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asyou-ankle-crop-cigarette-trouser-in-brown/22797359-1-brown"
    },
    {
      friendlyName: "Cigarette Trousers",
      linkUrl:
        "women/trousers-leggings/cigarette-trousers/cat/?cid=20268#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-slim-skim-cigarette-trousers-in-black/204144198-4"
    }
  ],
  2238: [
    {
      friendlyName: "Bikinis",
      linkUrl:
        "women/swimwear-beachwear/bikinis/cat/?cid=10117#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-ring-front-crop-bikini-top-in-glitter-zig-zag-print/202705365-1-zigzagprint"
    },
    {
      friendlyName: "Swimsuits",
      linkUrl:
        "women/swimwear-beachwear/swimsuits/cat/?cid=10118#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-asymmetric-one-shoulder-high-leg-swimsuit-in-black/203902474-1-black"
    },
    {
      friendlyName: "Beach clothing",
      linkUrl:
        "women/swimwear-beachwear/beach-clothing/cat/?cid=10119#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-long-sleeve-colour-block-crochet-knit-midaxi-beach-dress/203668687-1-multi"
    },
    {
      friendlyName: "Fuller Bust Swimwear DD+",
      linkUrl:
        "women/swimwear-beachwear/fuller-bust-swimwear-dd/cat/?cid=10120#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-fuller-bust-mix-and-match-step-front-underwired-bikini-top-in-gold-glitter/203255693-1-gold"
    },
    {
      friendlyName: "Underwire Swimsuits & Bikinis",
      linkUrl:
        "women/swimwear-beachwear/underwire-swimsuits-bikinis/cat/?cid=19294#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-mix-and-match-underwired-bikini-top-in-cobalt-blue/202735565-1-cobaltblue"
    },
    {
      friendlyName: "High Waisted Bikini",
      linkUrl:
        "women/swimwear-beachwear/high-waisted-bikini/cat/?cid=17551#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/groups/asos-design-curve-mix-and-match-step-front-underwired-bikini-in-sage-green/144197-group-1"
    },
    {
      friendlyName: "Beach Cover Ups",
      linkUrl:
        "women/swimwear-beachwear/beach-cover-ups/cat/?cid=29083#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-tie-side-maxi-beach-cover-up-in-black/204316856-1-black"
    },
    {
      friendlyName: "Cut Out Swimsuits",
      linkUrl:
        "women/swimwear-beachwear/cut-out-swimsuits/cat/?cid=29084#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-cut-out-plunge-swimsuit-with-trim-detail-in-red/202681672-1-red"
    },
    {
      friendlyName: "Bikini Tops",
      linkUrl:
        "women/swimwear-beachwear/bikini-tops/cat/?cid=19584#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-mix-and-match-micro-triangle-bikini-top-in-white/203791734-2"
    },
    {
      friendlyName: "Kaftans",
      linkUrl:
        "women/swimwear-beachwear/kaftans/cat/?cid=19140#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/south-beach-balloon-sleeve-chiffon-maxi-beach-kaftan-in-green/203882970-1-green"
    }
  ],
  9577: [
    {
      friendlyName: "New in",
      linkUrl: "women/curve-plus-size/new-in/cat/?cid=9578#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-curve-elasticated-back-satin-slip-midi-dress-in-grey-and-mocha-colourblock/203822923-1-greycolourblock"
    },
    {
      friendlyName: "Dresses",
      linkUrl: "women/curve-plus-size/dresses/cat/?cid=9579#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-curve-cotton-shirred-corset-midi-dress-in-floral-print/204196988-1-floral"
    },
    {
      friendlyName: "Tops",
      linkUrl: "women/curve-plus-size/tops/cat/?cid=9581#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/groups/asos-design-curve-wrap-tie-long-sleeve-beach-co-ord-in-black/143784-group-1"
    },
    {
      friendlyName: "Jeans",
      linkUrl: "women/curve-plus-size/jeans/cat/?cid=17079#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-curve-flared-jeans-in-mid-blue/204265354-1-midblue"
    },
    {
      friendlyName: "Trousers & leggings",
      linkUrl:
        "women/curve-plus-size/trousers-leggings/cat/?cid=9580#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-curve-clean-pull-on-cargo-trouser-in-white/204206996-1-white"
    },
    {
      friendlyName: "Coats & jackets",
      linkUrl:
        "women/curve-plus-size/coats-jackets/cat/?cid=9582#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-curve-lightweight-cotton-pocket-shacket-in-ecru/204114521-1-ecru"
    },
    {
      friendlyName: "Occasionwear",
      linkUrl:
        "women/curve-plus-size/occasionwear/cat/?cid=28898#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-curve-all-over-embellished-panelled-fringe-midi-in-nude/203240696-1-nude"
    },
    {
      friendlyName: "Swimwear & beachwear",
      linkUrl:
        "women/curve-plus-size/swimwear-beachwear/cat/?cid=9583#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-curve-crinkle-scoop-low-back-swimsuit-in-deep-orange/204143245-1-deeporange"
    },
    {
      friendlyName: "Nightwear & lingerie",
      linkUrl:
        "women/curve-plus-size/nightwear-lingerie/cat/?cid=20975#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-design-curve-sienna-lace-soft-body-in-black/204226489-1-black"
    },
    {
      friendlyName: "Activewear",
      linkUrl:
        "women/curve-plus-size/activewear/cat/?cid=28897#ctaref-cat_header",
      imageUrl:
        "images.asos-media.com/products/asos-4505-curve-icon-long-sleeve-run-top/22069195-1-black"
    }
  ]
};

export default visualCategoryLinksConfig;
